import { render, staticRenderFns } from "./fx.vue?vue&type=template&id=0a163148&scoped=true"
import script from "./fx.vue?vue&type=script&lang=js"
export * from "./fx.vue?vue&type=script&lang=js"
import style0 from "./fx.vue?vue&type=style&index=0&id=0a163148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a163148",
  null
  
)

export default component.exports